import React, { useEffect } from "react";
import { Select } from "antd";

const { Option } = Select;
const data = [
  {
    id: null,
    name: "сонго",
  },
  {
    id: "050000",
    name: "Хаан банк",
  },
  {
    id: "340000",
    name: "Төрийн банк",
  },
  {
    id: "150000",
    name: "Голомт банк",
  },
  {
    id: "390000",
    name: "М Банк",
  },
  {
    id: "040000",
    name: "Худалдаа хөгжлийн банк",
  },
  {
    id: "300000",
    name: "Капитрон банк",
  },
  {
    id: "320000",
    name: "Хас банк",
  },
];
const BankCodeSelect = ({ onChange, value }) => {
  const [loading, setLoading] = React.useState(false);

  return (
    <Select
      placeholder="Select a product type"
      onChange={onChange}
      value={value}
      loading={loading}
      style={{ width: "100%" }}
    >
      {data.map((item) => (
        <Option key={item.id} value={item.id}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default BankCodeSelect;
